import { call, all, put, takeLatest } from 'redux-saga/effects';
import * as Constants from './Constants';
import * as Actions from './actions';
// import logger from '../../components/common/ErrorBoundary/logger_new';
import { showLoader, hideLoader } from '../../components/common/Helpers/loader';
import { isCartCIThrottlePass, setSession } from '../../components/common/Helpers';
import { CART_CONTACT_INFO_INTG, cradleThrottleValues } from '../../components/common/Helpers/constants';

function* callCradleApi({ data }) {
  try {
    showLoader();
    yield put({ type: Constants.CRADLE_API_INIT });
    const response = yield call(Actions.postCradleApi, data);
    if (response && response.data && !response.data.errors) {
      if (data?.name?.includes(cradleThrottleValues.CART_CONTACT_INFO_INTG_PASSKEY)) {
        setSession(CART_CONTACT_INFO_INTG, isCartCIThrottlePass(response?.data?.throttleList) ? 'Y' : 'N');
      }
      if (response?.data?.throttleList.includes('autopay-preview')) {
        setSession('autoPayPreview', 'Y');
      }
      yield put({ type: Constants.STORE_CRADLE_THROTTLE_VALUE, response: response?.data?.throttleList });
    } else {
      yield put({ type: Constants.CRADLE_API_COMPLETED });
    }
  } catch (error) {
    yield put({ type: Constants.CRADLE_API_COMPLETED });
    console.log(error);
  } finally {
    hideLoader();
  }
}
function* actionWatcher() {
  yield takeLatest(Constants.CALL_CRADLE_API, callCradleApi);
}

export default function* rootSaga() {
  yield all([actionWatcher()]);
}
